import { Component,ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { SystemSettingService } from '../../services/system-settings.service';
import { ToasterService } from "../../../../common/services/toaster.service";
import { ModalController } from "@ionic/angular";
import { WebOrderTypeStepsPage } from "../web-order-type-steps/web-order-type-steps.page";
@Component({
  selector: 'app-web-order-type-admin-page',
  templateUrl: 'web-order-type-admin.page.html',
  styleUrls: [
    './web-order-type-admin.page.scss',
  ]
})
export class WebOrderTypeAdminPage {
  settingsFields:any[];
  systemSetting:any[];
   constructor(
        private systemSettingService: SystemSettingService,
        private toasterService: ToasterService,
        private modalController: ModalController
      ) { 
  
    }
  loading:boolean=true ;
  woOrderTypes:any;



  ngOnInit() {
    this.loadData(); 
  }

  async loadData() {
    this.loading=false;
    await this.systemSettingService.getWebOrderType().then((response) => {
        this.woOrderTypes = response;

      });
      
        this.loading=true;

    }
  async UpdateWebOrderType() {
      this.loading=false;
      await this.systemSettingService.updateWebOrderTypes(this.woOrderTypes).then((response) => {
        if (response =='success') {
          this.toasterService.presentToast(
            "primary",
            " The Item was Updated Successfully! ",
            "Success"
          );
             this.loading=true;
        } else {
          this.toasterService.presentToast(
            "danger",
            `Error Updating Web Customer Setting.`,
            "Error"
          );  
             this.loading=true;
         }
    });
      this.loading=true;
      }
  async editWebOrderType(typeCode) {
     const modal = await this.modalController.create({
          component: WebOrderTypeStepsPage,
          cssClass: "min-width-modal-md-wide grey-background",
          showBackdrop: true,
          backdropDismiss: true,
          keyboardClose: true,
          swipeToClose: true,
          componentProps: { typeCode: typeCode},
        });
    
        (await modal).present();
        const { data } = await(await modal).onDidDismiss();
    }

getEmailBoolean(field: string, wo: any): boolean {
    return wo[field] === '1' || wo[field] === 1;
  }

  setEmailBoolean(field: string, wo: any, value: boolean) {
    wo[field] = value ? '1' : '0';
  }
  
}